var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { createVNode, toRaw } from 'vue';
import { BeanBase, deepEqual, disposeInstance, Use } from 'zova';
import { Bean } from 'zova-module-a-bean';
import { Log } from 'zova-module-a-logger';
import { $UseBehavior } from '../lib/useBehavior.js';
import { BeanBehavior } from './bean.behavior.js';
export let BeanBehaviorsHolder = (_dec = Bean(), _dec2 = __z_BeanInfo({
  module: "a-behavior"
}), _dec3 = Use(), _dec4 = Reflect.metadata("design:type", typeof BeanBehavior === "undefined" ? Object : BeanBehavior), _dec5 = Log({
  args: false,
  childName: 'behavior',
  level: 'debug'
}), _dec6 = Reflect.metadata("design:type", Function), _dec7 = Reflect.metadata("design:paramtypes", [typeof IBehaviors === "undefined" ? Object : IBehaviors]), _dec(_class = _dec2(_class = (_class2 = class BeanBehaviorsHolder extends BeanBase {
  constructor(...args) {
    super(...args);
    this.options = void 0;
    this.composer = void 0;
    _initializerDefineProperty(this, "$$beanBehavior", _descriptor, this);
  }
  async initialize(options) {
    this.options = options;
    this.bean._setBean('$$behaviorTag', this.options.behaviorTag);
    // composer
    this.composer = await this.$$beanBehavior.createComposer(this._getBehaviorRoot());
    // watch
    const behaviors = this.options.behaviors;
    if (typeof behaviors === 'function') {
      this.$watch(behaviors, async (newValue, oldValue) => {
        if (deepEqual(newValue, oldValue)) return;
        await this.composer.load(this._getBehaviorRoot(newValue));
      });
    }
  }
  __dispose__() {
    disposeInstance(this.composer);
  }
  _getBehaviors() {
    let behaviors = this.options.behaviors;
    if (typeof behaviors === 'function') {
      behaviors = behaviors();
    }
    return behaviors;
  }
  _getBehaviorRoot(behaviors) {
    if (!behaviors) {
      behaviors = this._getBehaviors();
    }
    return $UseBehavior('a-behavior:root', {
      behaviors
    });
  }
  render(vNodeDefault, propsCustom) {
    const parent = this.ctx.instance;
    const {
      props,
      children
    } = parent.vnode;
    // props
    const propsNew = Object.assign({}, propsCustom ?? props);
    delete propsNew.behaviorTag;
    delete propsNew.behaviors;
    // render
    return this.composer.render(propsNew, propsNew => {
      if (vNodeDefault) return vNodeDefault(propsNew);
      return createVNode(toRaw(this.options.behaviorTag.component), propsNew, children);
    });
    // // ensure inner component inherits the async wrapper's ref owner
    // vnode.ref = parent.vnode.ref;
    // // pass the custom element callback on to the inner comp
    // // and remove it from the async wrapper
    // cast(vnode).ce = cast(parent.vnode).ce;
    // // delete cast(parent.vnode).ce;
    // // ok
    // return vnode;
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "$$beanBehavior", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "_getBehaviorRoot", [_dec5, _dec6, _dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "_getBehaviorRoot"), _class2.prototype), _class2)) || _class) || _class);